/**
 * Insere um grafo JSON-LD no `<head>`.
 *
 * SEGURANÇA — o escape aqui não é cosmético. O Helmet insere o conteúdo de
 * `<script>` sem escapar nada: no servidor concatena `tag.innerHTML` direto na
 * string do HTML (`HelmetUtils.js`, `const tagContent = tag.innerHTML || ...`)
 * e no cliente usa `dangerouslySetInnerHTML`. Sem tratamento, um título de
 * conteúdo contendo `</script>` fecharia a tag mais cedo e o restante do texto
 * viraria HTML executável — e títulos são texto que o editor digita.
 *
 * Trocar `<` por `\u003c` resolve sem quebrar o JSON: `\u003c` é escape válido
 * dentro de string JSON, então o consumidor lê exatamente o mesmo caractere, e
 * nenhuma sequência `</script>` sobrevive à serialização.
 */

import Helmet from '@plone/volto/helpers/Helmet/Helmet';
import React from 'react';

interface Props {
  graph: unknown[];
}

export const serializeJsonLd = (graph: unknown[]): string =>
  JSON.stringify({ '@context': 'https://schema.org', '@graph': graph }).replace(
    /</g,
    '\\u003c',
  );

export const JsonLd: React.FC<Props> = ({ graph }) => {
  if (!graph?.length) return null;

  return (
    <Helmet>
      <script type="application/ld+json">{serializeJsonLd(graph)}</script>
    </Helmet>
  );
};

export default JsonLd;
